/**
 * Admin 사이트 > 메인 영상 CRUD. 설명 필드 Quill.
 */
import { Logger } from "../../utils/Logger";
import { QuillEditor, stripBase64Images } from "../../components/QuillEditor";

function noop(controller: string, action: string): void {
    Logger.debug(`${controller}.${action} (no-op)`);
}

const CTRL_TAG = "AdminMainVideoController";

function initMainVideoQuill(): void {
    const form = document.getElementById("main-video-form") as HTMLFormElement | null;
    const editorEl = document.getElementById("main-video-content-editor");
    const contentInput = document.getElementById("main-video-content-input") as HTMLInputElement | null;
    if (!form || !editorEl || !contentInput) return;

    const uploadImageUrl = form.dataset.uploadImageUrl ?? "";
    const csrf =
        (form.querySelector('input[name="_token"]') as HTMLInputElement | null)?.value ?? "";

    let initialHtml = "";
    const initEl = document.getElementById("main-video-content-initial");
    if (initEl?.textContent) {
        try {
            initialHtml = JSON.parse(initEl.textContent) as string;
        } catch {
            initialHtml = "";
        }
    }

    const uploadConfig =
        uploadImageUrl && csrf
            ? {
                  uploadUrl: uploadImageUrl,
                  csrf,
                  fileKey: "image" as const,
                  getUrl: (json: Record<string, unknown>) =>
                      (json?.data as Record<string, unknown>)?.url as string | undefined,
              }
            : undefined;

    const quill = new QuillEditor(editorEl, {
        placeholder: "설명을 입력하세요. 이미지는 툴바 이미지 버튼으로 넣을 수 있습니다.",
        initialHtml,
        upload: uploadConfig,
    });
    quill.init();

    form.addEventListener(
        "submit",
        () => {
            contentInput.value = stripBase64Images(quill.getHtml());
        },
        true
    );
}

export const AdminMainVideoController = {
    index(): void {
        noop(CTRL_TAG, "index");
    },
    create(): void {
        initMainVideoQuill();
    },
    store(): void {
        noop(CTRL_TAG, "store");
    },
    edit(): void {
        initMainVideoQuill();
    },
    update(): void {
        noop(CTRL_TAG, "update");
    },
    destroy(): void {
        noop(CTRL_TAG, "destroy");
    },
};
